import { Button } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";

export function GoogleLoginButton() {
  const { t } = useTranslation();
  const { loginWithGoogle } = useAuth();

  return (
    <Button
      variant="outlined"
      startIcon={<GoogleIcon />}
      onClick={loginWithGoogle}
      fullWidth
      size="large"
      sx={{
        borderColor: "divider",
        color: "text.primary",
        py: 1.5,
        "&:hover": { borderColor: "primary.main" },
      }}
    >
      {t("login.continueWithGoogle")}
    </Button>
  );
}
